import { defineStore } from 'pinia';

import { updateSuperProperties } from '@/helpers/analytics/mixpanel';
import { axios } from '@/helpers/axios';

import { useAuthStore } from './auth';

export const useIntercomStore = defineStore('intercom', {
  state: () => ({}), // Define your state if needed
  actions: {
    async fetchIntercom() {
      try {
        const isLogged = useAuthStore().isUserLogged;
        if (!isLogged) {
          return;
        }
        const response = await axios.get('/intercom');
        const data = response.data.data;

        if (response.data.success) {
          const w = window as unknown as {
            intercomSettings: unknown;
            Intercom: unknown;
            attachEvent: (event: string, listener: EventListener) => void;
            addEventListener: (event: string, listener: EventListener, status: boolean) => void;
          };
          const lowest_views_listing = data.lowest_views_listing;
          const shopName = (typeof data.shop === 'object' && data.shop !== null) ? data.shop.shop_name : data.shop;

          updateSuperProperties({
            'Shop Listings': data.active_listings,
            'Shop Sales': data.sales,
          });

          w.intercomSettings = {
            api_base: 'https://api-iam.intercom.io',
            app_id: 'w7z8c9mt',
            memberid: data.member_id,
            plan_id: data.plan_id,
            shop: shopName,
            shops_count: data.shops_count,
            plan: data.plan,
            name: data.name, // Full name
            email: data.email, // Email address
            created_at: data.created_at, // Signup date as a Unix timestamp
            user_hash: data.user_hash,
            kl: null, // push null to remove old data
            kt: null, // push null to remove old data
            lh_quota: data.lh_quota,
            cs_quota: data.cs_quota,
            kt_quota: data.kt_quota,
            kl_quota: data.kl_quota,
            active_listings: data.active_listings,
            sales: data.sales,
            ref: data.referrer,
            "Subscribed to Newsletter": data.newsletter,
            "Last Login": data.last_login,
            "Viewed Plans Page": data.plan_page_visit,
            "hc_missing_image_count": data.hc_missing_image_count,
            "hc_one_word_tag_count": data.hc_one_word_tag_count,
            "hc_missing_tag_count": data.hc_missing_tag_count,
            "hc_spelling_issue_count": data.hc_spelling_issue_count,
            zero_revenue_customer: data["Zero-revenue customer"],
            onboarding_goal: data.onboarding_goal,
            searched_for_keyword: data.searched_for_keyword,
            added_keyword_to_list: data.added_keyword_to_list,
            "trialed": data.trialed,
          };

          // @ts-ignore - clarity is a global function from Microsoft Clarity script
          if (typeof clarity === "function") {
            // @ts-ignore - clarity is a global function from Microsoft Clarity script
            clarity("set", "member_id", data.member_id.toString());
            // @ts-ignore - clarity is a global function from Microsoft Clarity script
            clarity("set", "plan_id", data.plan_id.toString());
            // @ts-ignore - clarity is a global function from Microsoft Clarity script
            clarity("set", "shop_name", shopName);
            // @ts-ignore - clarity is a global function from Microsoft Clarity script
            clarity("set", "plan_type", data.plan);
          }

          lowest_views_listing.forEach((value, index) => {
            w.intercomSettings[`lowest_views_${index + 1}`] = value;
          });

          // Intercom widget loading logic
          (function () {
            const ic = w.Intercom;
            if (typeof ic === 'function') {
              ic('reattach_activator');
              ic('update', w.intercomSettings);
            } else {
              const d = document;
              const i = function (...args: unknown[]) {
                i.c(args);
              };
              i.q = [];
              i.c = function (args: unknown) {
                i.q.push(args);
              };
              w.Intercom = i;
              const l = function () {
                const s = d.createElement('script');
                s.type = 'text/javascript';
                s.async = true;
                s.src = 'https://widget.intercom.io/widget/w7z8c9mt';
                const x = d.getElementsByTagName('script')[0];
                x.parentNode?.insertBefore(s, x);
              };
              if (document.readyState === 'complete') {
                l();
              } else if (w.attachEvent) {
                w.attachEvent('onload', l);
              } else {
                w.addEventListener('load', l, false);
              }
            }
          })();
        }
      } catch (error) {
        console.error('Error fetching Intercom data', error);
      }
    },
  },
});
